// Centralized lucide icon map for offers
// Keeps icon names string-based in DB and resolved to actual components in UI.
import {
  Wrench, Thermometer, Home as HomeIcon, Zap, PaintBucket, Truck, Sun, Bug,
  DoorOpen, Lock, Fan, Container, Toilet, Plane, Droplets, Wind, Trash2,
  Bath, Settings, Square, Flame, Phone, Hammer, Shield, Sparkles, Briefcase,
  Star, Heart, Globe, MapPin, Building2, Car, GraduationCap, CreditCard,
  Headphones, Camera, Music, Gift, ShoppingBag, Tag,
} from "lucide-react";

export const OFFER_ICONS = {
  Wrench, Thermometer, Home: HomeIcon, Zap, PaintBucket, Truck, Sun, Bug,
  DoorOpen, Lock, Fan, Container, Toilet, Plane, Droplets, Wind, Trash2,
  Bath, Settings, Square, Flame, Phone, Hammer, Shield, Sparkles, Briefcase,
  Star, Heart, Globe, MapPin, Building2, Car, GraduationCap, CreditCard,
  Headphones, Camera, Music, Gift, ShoppingBag, Tag,
};

export const OFFER_ICON_NAMES = Object.keys(OFFER_ICONS);

export const getOfferIcon = (name) => OFFER_ICONS[name] || Phone;

export const COLOR_PRESETS = [
  "from-blue-500 to-cyan-500",
  "from-cyan-500 to-blue-500",
  "from-blue-600 to-blue-400",
  "from-red-500 to-orange-500",
  "from-orange-500 to-yellow-500",
  "from-yellow-500 to-amber-500",
  "from-yellow-400 to-orange-400",
  "from-green-600 to-green-400",
  "from-emerald-500 to-teal-500",
  "from-teal-500 to-cyan-500",
  "from-purple-500 to-pink-500",
  "from-pink-500 to-rose-500",
  "from-indigo-500 to-purple-500",
  "from-sky-500 to-blue-500",
  "from-sky-600 to-blue-500",
  "from-slate-500 to-slate-400",
  "from-slate-600 to-slate-500",
  "from-stone-500 to-stone-400",
  "from-gray-500 to-gray-400",
  "from-zinc-500 to-zinc-400",
  "from-amber-600 to-yellow-500",
  "from-blue-400 to-cyan-400",
];

export const TRAFFIC_SOURCES = [
  "Google Ads",
  "Meta Ads",
  "Facebook Marketplace",
  "TikTok Ads",
  "YouTube Ads",
  "Native Ads",
  "Display Ads",
  "Email",
  "SMS",
  "SEO / Organic",
  "Bing Ads",
  "Pinterest Ads",
  "Snapchat Ads",
  "Push Notifications",
  "Affiliate / Partner",
];

export const OFFER_CATEGORIES = [
  "Home Services",
  "Emergency",
  "Travel",
  "Rentals",
  "Insurance",
  "Solar",
  "Legal",
  "Finance",
  "Medical",
  "Other",
];

export const PAYMENT_TERMS = ["Weekly", "Net 7", "Net 10", "Net 15", "Net 30"];
